import React from 'react';

const TotalTest = ({ width = 16, height = 16, className, color, ...rest }) => {
  return (
    <svg
      role="presentation"
      aria-hidden="true"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      color={color}
      {...rest}
    >
      <path
        d="M9.5 7.5C10.3284 7.5 11 6.82843 11 6C11 5.17157 10.3284 4.5 9.5 4.5C8.67157 4.5 8 5.17157 8 6C8 6.82843 8.67157 7.5 9.5 7.5Z"
        stroke="#6E7781"
        stroke-width="1.2"
      />
      <path
        d="M11.5 14C12.3284 14 13 13.3284 13 12.5C13 11.6716 12.3284 11 11.5 11C10.6716 11 10 11.6716 10 12.5C10 13.3284 10.6716 14 11.5 14Z"
        stroke="#6E7781"
        stroke-width="1.2"
      />
      <path
        d="M3.54827 1.85647L1.31445 1.85741C1.31445 1.85741 2.31457 1.85895 3.54827 1.85843C4.78198 1.85791 5.78209 1.85552 5.78209 1.85552L3.54827 1.85647Z"
        fill="#6E7781"
        stroke="#6E7781"
        stroke-width="1.2"
      />
      <path
        d="M4 3V9.04545C4 10.6739 4 11.4882 4.45561 11.9941C4.91122 12.5 5.64452 12.5 7.11111 12.5H10.5"
        stroke="#6E7781"
        stroke-width="1.2"
      />
      <path
        d="M4 2C4 3.88562 4 4.82843 4.45561 5.4142C4.91122 6 5.64452 6 7.11111 6H8"
        stroke="#6E7781"
        stroke-width="1.2"
      />
    </svg>
  );
};

export { TotalTest };
